import script from "./FloatingToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingToolbar.vue?vue&type=script&setup=true&lang=js"

import "./FloatingToolbar.vue?vue&type=style&index=0&id=7bc6dad7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bc6dad7"]])

export default __exports__